import { render, staticRenderFns } from "./FileInfo.vue?vue&type=template&id=1f390511&scoped=true&"
import script from "./FileInfo.vue?vue&type=script&lang=js&"
export * from "./FileInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f390511",
  null
  
)

export default component.exports